




























import Vue from 'vue'
import ProjectDetails from '@/components/project/ProjectDetails.vue'
import { Project } from '@/model/Project'
import ItemsHorizontalList from '@/components/ItemsHorizontalList.vue'

export default Vue.extend({
  name: 'Project',

  props: {
    slug: {
      type: String,
    },
  },

  computed: {
    relatedProjectsLink: function (): string {
      if (!this.project) {
        return ''
      }

      const tags = []

      for (let i = 0; i < this.project.tags.length; i++) {
        tags.push(this.project.tags[i].name)
      }

      return '/projects/all/' + tags.join(',') + '/any-contest/newest'
    },
  },

  components: {
    ProjectDetails,
    ItemsHorizontalList,
  },

  mounted() {
    (this as any).fetchProject()
  },

  data: () => ({
    project: null as Project | null,
    relatedProjects: [] as Project[],
  }),

  methods: {
    fetchProject: function () {
      this.$api
        .get('/projects/slug/' + (this as any).slug)
        .then((response) => {
          (this as any).project = response.data

          if (!(this as any).project) {
            return
          }

          if ((this as any).project.description === undefined) {
            (this as any).project.description = null
          }

          this.$api
            .get((this as any).project['@id'] + '/related')
            .then((response: any) => {
              (this as any).relatedProjects = response.data['hydra:member']
            })
        })
        .catch(() => {
          this.$router.push('/404')
        })
    },

    updateUserScore: function (userScore: number) {
      if (!this.project) {
        return
      }

      this.project.userScore = userScore
    },

    updateUserAverageScore: function (userAverageScore: number) {
      if (!this.project) {
        return
      }

      this.project.score = userAverageScore
    },
  },

  watch: {
    '$route.params': function () {
      (this as any).fetchProject()
    },
  },
})
